import { Alert, Collapse } from 'antd';
import styled from 'styled-components';

import { lightAiPurple, aiPurple } from '../constants/colors';
// Gambiarras pra evitar o erro:
// ```Type 'StyledComponent<CompoundedComponent, any, {}, never>' is not assignable to type 'CompoundedComponent'.
//   Type 'StyledComponent<CompoundedComponent, any, {}, never>' is not assignable to type 'FC<AlertProps>'.
//     Call signature return types 'ReactElement<WithOptionalTheme<{ style?: CSSProperties | undefined; type?: "success" | "info" | "warning" | "error" | undefined; className?: string | undefined; role?: string | undefined; ... 15 more ...; closeIcon?: ReactNode; } & Partial<...>, any>, string | JSXElementConstructor<...>>' and 'ReactElement<any, any> | null' are incompatible.
//       The types of 'key' are incompatible between these types.
//         Type 'Key | null' is not assignable to type 'string | null'.
//           Type 'number' is not assignable to type 'string'.```;

export const AIAlert: typeof Alert = styled(Alert)`
  &&& {
    background-color: ${lightAiPurple};
    color: black;
    margin-bottom: 1em;
    border: 1px solid ${aiPurple};
    border-radius: 7px;
  }
  & .ant-alert-message {
    color: black;
    b {
      color: ${aiPurple};
    }
  }
` as typeof Alert;

export const AICollapse = styled(Collapse)`
  &&& {
    padding-left: 15px;
    padding-right: 15px;
    background-color: ${lightAiPurple};
    color: black;
    margin-bottom: 1em;
    border: 1px solid ${aiPurple};
    border-radius: 7px;
  }
  & .ant-collapse-header {
    color: black;
    b {
      color: ${aiPurple};
    }
  }
`;
